export const FIREBASE_NOTIFICATIONS_LOADING = 'FIREBASE_NOTIFICATIONS_LOADING';
export const FIREBASE_NOTIFICATIONS_ERROR = 'FIREBASE_NOTIFICATIONS_ERROR';
export const FIREBASE_NOTIFICATIONS_SUCCESS = 'FIREBASE_NOTIFICATIONS_SUCCESS';
